import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { Car } from '@one-thd/sui-icons';
import { pushEventInfo } from './utils';

// Ported one-to-one from @thd-olt-component-react/active-orders'
// components/fulfillment-details-actions/CurbsidePickup.tsx (OOP-4059) — see
// FulfillmentDetailsDrawer.tsx's doc comment. LIFE_CYCLE_EVENT_BUS is a host-supplied global
// already used elsewhere in this repo (ActiveOrdersTablePresentational.tsx), not a new dependency.
export interface CurbsidePickupProps {
  orderId?: string;
  storeId?: string;
}

export const CurbsidePickup: React.FC<CurbsidePickupProps> = ({ orderId, storeId }) => {
  const handleCurbsideClick = () => {
    pushEventInfo({
      category: { primaryCategory: 'button submission' },
      eventInfo: { eventName: 'Curbside Pickup' },
      myAccount: { settings: 'Curbside Pickup button clicked' }
    });

    if ((window as any)?.LIFE_CYCLE_EVENT_BUS?.trigger) {
      (window as any).LIFE_CYCLE_EVENT_BUS.trigger('NATIVE_APP.OPEN_CURBSIDE', { storeId, orderId });
    }
  };

  return (
    <Button startIcon={Car} onClick={handleCurbsideClick} data-testid="curbside-pickup-button" fullWidth>
      Get it Curbside
    </Button>
  );
};
